//
// ExportRequest.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../BIRDModel";
import "./TotalsPlacement";

var ExportRequest = createModule("BIRD::ExportRequest", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        presentation: 7,
        hideAggregationLabels: 2,
        variables: 7,
        startRow: 4,
        resultDefinition: 7,
        totalsPlacement: 4,
        endRow: 4,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default ExportRequest;
